import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileSplashScreen = (data) => openPopupHelper({ popupName: popupNames.MOBILE_SPLASH_SCREEN, data });
